@for (button of buttons; track button.label) {
  <button
    [class.dark]="darkTheme"
    [class.toggled]="button.label === 'BOOKMARK' && isBookmarked"
    (click)="actionClick($event, button)"
    [title]="button.icon"
  >
    <wb-icon [name]="button.icon"></wb-icon>
  </button>
}
